import { render, staticRenderFns } from "./CurrentUserTweets.vue?vue&type=template&id=4828cccc&scoped=true"
import script from "./CurrentUserTweets.vue?vue&type=script&lang=js"
export * from "./CurrentUserTweets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4828cccc",
  null
  
)

export default component.exports